import { render, staticRenderFns } from "./app-banner.vue?vue&type=template&id=f6c27dc4&scoped=true"
import script from "./app-banner.vue?vue&type=script&lang=js"
export * from "./app-banner.vue?vue&type=script&lang=js"
import style0 from "./app-banner.vue?vue&type=style&index=0&id=f6c27dc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c27dc4",
  null
  
)

export default component.exports